import { colors } from '@chegg-ui/theme'

export const baseStepProps = {
  disableScrolling: true,
  disableBeacon: true,
  spotlightPadding: 2,
  styles: {
    spotlight: {
      borderRadius: 0,
    },
    overlay: {
      cursor: 'unset',
    },
  },
}

export const baseConfigProps = {
  disableOverlayClose: true,
  disableCloseOnEsc: true,
  hideBackButton: true,
  styles: {
    options: {
      arrowColor: colors.royalXlight,
    },
    buttonClose: {
      display: 'none',
    },
    buttonNext: {
      display: 'none',
    },
    tooltipContent: {
      padding: 0,
    },
    tooltip: {
      padding: 0,
      width: '100%',
    },
    tooltipFooter: {
      marginTop: 0,
    },
  },
}
